export default __webpack_public_path__ + "static/media/83.687a9a09.jpeg";